import type { Ref } from 'vue';
import {
  computed,
} from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getSmartFiltersTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partnership_program: {
        conditions: {
          create_edit: {
            main_params: {
              form: {
                cpa: 'TYPE_OF_TRANSACTION.CPA',
                cpl: 'TYPE_OF_TRANSACTION.CPL',
                revenue_share: 'TYPE_OF_TRANSACTION.REVENUE_SHARE',
                hybrid: 'TYPE_OF_TRANSACTION.HYBRID',
                ggr_minus_bonuses: 'TYPE_OF_TRANSACTION.GGR_MINUS_BONUSES',
              },
            },
          },
        },
      },
    },
    common: {
      reports: {
        configuration: {
          segments: {
            tabs: {
              compare: {
                condition_selector: 'SEGMENTS_COMPARE_CONDITION_SELECTOR',
                compare_value: 'SEGMENTS_COMPARE_COMPARE_VALUE',
                add_condition: 'SEGMENTS_COMPARE_ADD_CONDITION',
                remove_condition: 'SEGMENTS_COMPARE_REMOVE_CONDITION',
                and: 'SEGMENTS_COMPARE_AND',
                or: 'SEGMENTS_COMPARE_OR',
                greater_than: 'SEGMENTS_COMPARE_GREATER_THAN',
                less_than: 'SEGMENTS_COMPARE_LESS_THAN',
                greater_than_or_equal: 'SEGMENTS_COMPARE_GREATER_THAN_OR_EQUAL',
                less_than_or_equal: 'SEGMENTS_COMPARE_LESS_THAN_OR_EQUAL',
                equal: 'SEGMENTS_COMPARE_EQUAL',
              },
            },
          },
        },
      },
    },
  }));
}
